import { render, staticRenderFns } from "./Stalls.vue?vue&type=template&id=74422dbc&scoped=true"
import script from "./Stalls.vue?vue&type=script&lang=js"
export * from "./Stalls.vue?vue&type=script&lang=js"
import style0 from "./Stalls.vue?vue&type=style&index=0&id=74422dbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74422dbc",
  null
  
)

export default component.exports